import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'ap-south-1_Xu7avtAro',
  ClientId: '7kfp857ijksl7atkbu3e1kj400',
};

export default new CognitoUserPool(poolData);